// The modules supported by module switcher.
export enum Module {
    Mail,
    Calendar,
    People,
    FilesHub,
    Tasks,
    OutlookSpaces,
}
